// extracted by mini-css-extract-plugin
export default {"center":"CheckResultPage_center__hL4Z1","btnWrapper":"CheckResultPage_btnWrapper__iFMMU"};